module.exports = __webpack_public_path__ + "img/confirm-modal.cd869c8d.png";